<div class="!pr-[40px] !mb-[60px] flex">
  <div class="!w-[100%]">
    <div class="h-auto !bg-[#F8F8F8]">
      <div class="container flex !pt-[25px] !pb-[25px]">
        <h3 class="rfp-request !ml-[20px]">
          {{ projectName }} - {{ labels.rfpMode }} Requests
        </h3>
      </div>
    </div>

    <app-filter-tool></app-filter-tool>

    <table class="w-full bg-[#fcfcfd] table-auto !mt-[20px] ml-[16px]">
      <thead
        class="h-[80px] bg-[#DEE2E6] text-[#000000] !text-center justify-center !p-[20px]"
      >
        <tr>
          <th class="px-4 py-2 text-center w-auto header-column">
            {{ labels.rfpMode }} No
          </th>
          <th class="px-4 py-2 text-center w-auto header-column">Title</th>
          <th class="px-4 py-2 text-center w-auto header-column">
            Contract Type
          </th>
          <th class="px-4 py-2 text-center w-auto header-column">Issue Date</th>
          <th class="px-4 py-2 text-center w-auto header-column">
            Submission Deadline
          </th>
          <th class="px-4 py-2 text-center w-auto header-column">
            Clarification Date
          </th>
          <th class="px-4 py-2 text-center w-auto header-column">
            Contract Start Date
          </th>

          <th class="px-4 py-2 text-center w-auto">Project Completion Date</th>
        </tr>
      </thead>
      <tbody class="!text-center">
        <ng-container>
          <tr
            *ngFor="let item of data; let i = index"
            class="hover:bg-gray-200 border-b-0"
          >
            <td
              class="border-b-0 px-4 py-2 w-auto cursor-pointer"
              (click)="navigateToDetailPage(item?.id)"
            >
              {{ projectIdentifier }} {{ item?.reference_number }}
            </td>
            <td
              class="border-b-0 px-4 py-2 w-auto cursor-pointer"
              (click)="navigateToDetailPage(item?.id)"
            >
              {{ item?.title }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto cursor-pointer !pl-[45px]">
              {{ item?.contract_type_details }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto !pl-[45px]">
              {{ item?.issue_date | date : "yyyy-MM-dd" }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto !pl-[45px]">
              {{ item?.submission_deadline | date : "yyyy-MM-dd" }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto !pl-[45px]">
              {{ item?.clarification_deadline | date : "yyyy-MM-dd" }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto !pl-[45px]">
              {{ item?.contract_start_date | date : "yyyy-MM-dd" }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto !pl-[45px]">
              {{ item?.project_completion_date | date : "yyyy-MM-dd" }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div class="flex justify-center w-[100%]" *ngIf="data?.length === 0">
      <span class="mt-[24px]">No request available</span>
    </div>
  </div>
</div>
